'use client';
import { twMerge } from '@shared/themes';
import { useState, type ComponentProps, type ReactNode } from 'react';
import { SegmentationLinks } from '../../SegmentationLinks/SegmentationLinks';
import type { GamesCategoryFilter } from '../../games/types/types';
import { JackpotBonanza } from '../JackpotBonanza/JackpotBonanza';
import { JackpotOverdrive } from '../JackpotOverdrive/JackpotOverdrive';
import { JackpotRapidFire } from '../JackpotRapidFire/JackpotRapidFire';
import type { JackpotOffer } from '../types';

type JackpotsPanelProps = ComponentProps<'section'> & {
  jackpots: JackpotOffer[];
  bonanzaGamesFilter: GamesCategoryFilter;
  overdriveGamesFilter: GamesCategoryFilter;
  rapidfireGamesFilter: GamesCategoryFilter;
};

function JackpotsPanel({ jackpots, bonanzaGamesFilter, overdriveGamesFilter, rapidfireGamesFilter, className, ...props }: JackpotsPanelProps) {
  const [selectedCategory, setSelectedCategory] = useState<JackpotOffer>(jackpots[0]!);

  const contentComponents: Record<JackpotOffer, ReactNode> = {
    bonanza: <JackpotBonanza gamesFilter={bonanzaGamesFilter} />,
    overdrive: <JackpotOverdrive gamesFilter={overdriveGamesFilter} />,
    rapidfire: <JackpotRapidFire gamesFilter={rapidfireGamesFilter} />,
  };

  return (
    <section className={twMerge('dark bg-secondary pt-7 pb-10 flex flex-col gap-y-4 items-center', className)} {...props}>
      <SegmentationLinks items={jackpots} selectedId={selectedCategory} namespace="casino.jackpots" onSelect={setSelectedCategory} />
      {contentComponents[selectedCategory]}
    </section>
  );
}

export { JackpotsPanel };
